<template>
  <div>
    <el-avatar :src="getAvatar()"></el-avatar>
    <br/>
    <span class="overNone">{{ getName() }}</span>
  </div>

</template>

<script>
import {getCloudUrl} from "@/utils/urlutil";
import {getDisplayName} from "@/utils/userutil";

export default {
  name: "UserInfo",
  props: {
    user: {
      Object
    }
  },
  methods: {
    getAvatar() {
      return getCloudUrl(this.user.avatar)
    },
    getName() {
      return getDisplayName(this.user)
    }
  }
}
</script>

<style scoped>
.overNone{
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
</style>